import React from "react";
import { Instagram, Twitter, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer
      className="relative bg-[#1C1914] text-[#FFFDF5] px-5 md:px-10 pt-16 pb-10"
      data-testid="footer-section"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-7">
          <div className="font-display text-[28vw] md:text-[18rem] leading-[0.85] uppercase tracking-tighter" data-testid="footer-wordmark">
            DUDS<span className="text-[#FDE047]">.</span>
          </div>
          <p className="mt-4 font-condensed text-lg md:text-xl uppercase tracking-widest text-[#FFFDF5]/70 max-w-md">
            Apparel for the sour. Drawn poorly. Printed on purpose.
          </p>
        </div>

        <div className="md:col-span-5 space-y-6">
          <div>
            <p className="font-condensed text-sm uppercase tracking-widest text-[#FDE047]">// follow our descent</p>
            <div className="flex gap-3 mt-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-[#FFFDF5] p-3 hover:bg-[#FDE047] hover:text-[#1C1914] transition-colors"
                aria-label="Instagram"
                data-testid="social-link-instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-[#FFFDF5] p-3 hover:bg-[#FDE047] hover:text-[#1C1914] transition-colors"
                aria-label="Twitter"
                data-testid="social-link-twitter"
              >
                <Twitter size={20} />
              </a>
              <a
                href="mailto:whatsup@dudsapparel.com"
                className="border-2 border-[#FFFDF5] p-3 hover:bg-[#FDE047] hover:text-[#1C1914] transition-colors"
                aria-label="Email"
                data-testid="social-link-email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>

          <div className="space-y-2 font-condensed text-lg uppercase tracking-widest">
            <a href="#lookbook" className="block hover:text-[#FDE047]" data-testid="footer-link-lookbook">Lookbook</a>
            <a href="#about" className="block hover:text-[#FDE047]" data-testid="footer-link-about">Our excuses</a>
            <a href="#notify" className="block hover:text-[#FDE047]" data-testid="footer-link-notify">Waitlist</a>
          </div>
        </div>
      </div>

      <div className="border-t-2 border-[#FFFDF5]/30 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 font-condensed text-sm uppercase tracking-widest">
        <span data-testid="footer-copy">© DUDS — Don't sue us.</span>
        <span className="text-[#FFFDF5]/60" data-testid="footer-tagline">Already dead, just awaiting confirmation.</span>
      </div>
    </footer>
  );
};

export default Footer;
